import { ToggleButton } from '@mui/material'
import type { FC, ReactNode } from 'react'
import { Suspense } from 'react'
import LoadingPage from 'src/components/LoadingPage'
import { StyledToggleButtonGroup } from 'src/components/OrderSelect'

const UserProfileSubTab: FC<{
  tabs: [string, string | ReactNode, ReactNode][]
  currentTab: string
  onChange: (value: string) => any
  children?: ReactNode
}> = ({ tabs, currentTab, onChange }) => {
  return (
    <div>
      <div className="pb-4">
        <StyledToggleButtonGroup
          exclusive
          size="small"
          value={currentTab}
          onChange={(_, tab: string) => {
            if (tab == null) return
            onChange(tab)
          }}
        >
          {tabs.map(([tab, label]) => {
            return (
              <ToggleButton key={tab} value={tab}>
                <span className="normal-case inline-flex items-center">
                  {label}
                </span>
              </ToggleButton>
            )
          })}
        </StyledToggleButtonGroup>
      </div>
      <Suspense fallback={<LoadingPage />}>
        {tabs.find(([tab]) => tab === currentTab)?.[2]}
      </Suspense>
    </div>
  )
}

export default UserProfileSubTab
